// Module
var code = "<div class=notification data-id=\"<%= id %>\"> <p class=notificationTitle> <span class=notificationFrom> Advertiser <%= network_id %> <span> <span class=notificationDateTime><%= mo.format(\"L LT\") %></span> </span></span></p> <p style=word-break:break-word class=\"<% if (!read_ts) {%>text-bold<%} %>\"><%= body %></p> </div> ";
// Exports
module.exports = code;